// extracted by mini-css-extract-plugin
export var activityContainer = "_hb-0";
export var typingIndicatorContainer = "_hb-1";
export var typingIndicatorDot = "_hb-2";
export var wave = "_hb-3";